<template>
  <!-- LOGIN MODAL -->
  <div
    class="modal fade"
    id="loginModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="loginModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
      <form id="login_form" @submit.prevent="login">
        <div class="modal-content">
          <div class="modal-header p-4">
            <h5 class="fw-bold mb-0" id="loginModalLabel">Login</h5>
            <a
              href="#"
              class="btn btn-default btn-icon btn-icon-sm rounded-circle"
              role="button"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="fas fa-times"></i>
            </a>
          </div>
          <div class="modal-body p-0">
            <div class="card-body border-bottom p-4">
              <div class="col-12 mb-3 align-items-center">
                <div v-if="!is_theme_dark" class="align-items-center">
                  <img
                    class="rounded mx-auto d-block"
                    src="@/assets/img/rent-ease-logo.png"
                    alt="Responsive image"
                    width="20%"
                    height="20%"
                  />
                  <div class="col-12 align-items-center">
                    <h4
                      class="d-lg-block fw-bold mb-0"
                      style="text-align: center"
                    >
                      <span style="color: #012035">Rent</span
                      ><span class="text-primary">Ease</span>
                    </h4>
                  </div>
                </div>
                <div v-else class="align-items-center">
                  <img
                    class="rounded mx-auto d-block"
                    src="@/assets/img/rent-ease-logo-light.png"
                    alt="Responsive image"
                    width="20%"
                    height="20%"
                  />
                  <div class="col-12 align-items-center">
                    <h4
                      class="d-lg-block fw-bold mb-0"
                      style="text-align: center"
                    >
                      <span style="color: #fff">Rent</span
                      ><span class="text-primary">Ease</span>
                    </h4>
                  </div>
                </div>
              </div>
              <div class="row g-3 g-md-4">
                <div class="col-12">
                  <input
                    class="form-control"
                    placeholder="Email"
                    v-model="email_address"
                    type="email"
                    required
                  />
                </div>
                <div class="col-12">
                  <input
                    class="form-control"
                    placeholder="Password"
                    type="password"
                    v-model="password"
                    required
                  />
                </div>
                <div class="col-12">
                     <button type="submit" class="btn btn-primary btn-lg w-100">Login</button>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer d-flex gap-2">
            <button
            type="button"
            class="btn btn-transparent btn-sm"
            data-bs-dismiss="modal"
          >
            Clear all
          </button>
           
          </div> -->
        </div>
      </form>
    </div>
  </div>
  <!-- END LOGIN MODAL -->
</template>
<script>
export default {
  name: "Authentication",
  data: () => ({
    url: process.env.VUE_APP_API_URL,
    email_address: "",
    password: "",
    is_registered: false,
    is_logged_in: false,
    is_theme_dark: false
  }),
  computed: {
    dialog: {
      get: function () {
        return this.modalData.dialog;
      },
      // setter
      set: function () {
        this.closeModal();
      },
    },
  },
  mounted(){
    if (localStorage.getItem("_theme") === null) {
      localStorage.setItem("_theme", "light");
    } else {
      if (localStorage.getItem("_theme") == "light") {
        this.is_theme_dark = false;
      } else {
        this.is_theme_dark = true;
      }
    }
  },
  methods: {
    async login() {
      var form = document.getElementById("login_form");
      var elements = form.elements;

      for (var i = 0, len = elements.length; i < len; ++i) {
        elements[i].disabled = true;
      }

      const formData = new FormData();
      formData.append("userName", this.email_address);
      formData.append("userPassword", this.password);

      try {
        const res = await axios.post(this.url + "/api/login", formData);
        if (res.data.success == false) {
          this.email_address = "";
          this.password = "";
          this.is_registered = false;
          alert("Your email address or password is incorrect.");
        } else {
          this.closeModal();
          location.reload();
          localStorage.setItem("userEmail", res.data.userid);
          localStorage.setItem("userName", res.data.name);
        }
      } catch (error) {
        if (error.response.data.success == false) {
          this.email_address = "";
          this.password = "";
          this.is_logged_in = false;
          this.is_registered = false;
          alert("Your email address or password is incorrect.");
        }
      } finally {
        for (var i = 0, len = elements.length; i < len; ++i) {
          elements[i].disabled = false;
        }
      }
    },
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>
